var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.30047 1.86821C8.84459 0.964062 10.1554 0.964062 10.6995 1.86821L12.3623 4.63121C12.5578 4.95603 12.8767 5.18769 13.246 5.27322L16.3876 6.00082C17.4156 6.23892 17.8207 7.48558 17.1289 8.28247L15.015 10.7177C14.7665 11.004 14.6447 11.3788 14.6775 11.7565L14.9563 14.9692C15.0475 16.0205 13.9871 16.791 13.0154 16.3793L10.0461 15.1214C9.69706 14.9735 9.30294 14.9735 8.95387 15.1214L5.98459 16.3793C5.01294 16.791 3.95247 16.0205 4.0437 14.9692L4.32252 11.7565C4.3553 11.3788 4.23351 11.004 3.985 10.7177L1.87106 8.28247C1.17931 7.48558 1.58437 6.23892 2.61241 6.00082L5.75402 5.27322C6.12334 5.18769 6.44219 4.95603 6.63767 4.63121L8.30047 1.86821Z",
    stroke: "#F4A51D",
    strokeWidth: 1.75
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarOutline);
export default __webpack_public_path__ + "static/media/star-outline.da4f45427df884097f1514903380fcd9.svg";
export { ForwardRef as ReactComponent };